const dayDatePattern = new RegExp(
  '^(\\d\\d\\.\\d\\d\\s*)+/?(\\s*\\d\\d\\.\\d\\d\\s*)+$',
  'u',
);

export const getTagsFromDayDate = (dayDate: string): string[] => {
  const isCorrect = dayDatePattern.test(dayDate);

  if (isCorrect) {
    const subgroupsDates = dayDate.split('/');
    if (subgroupsDates.length === 2) {
      subgroupsDates[0] = subgroupsDates[0].trim();
      subgroupsDates[1] = subgroupsDates[1].trim();

      const subgroup1 = subgroupsDates[0].split(' ');
      const subgroup2 = subgroupsDates[1].split(' ');

      return [...subgroup1, ...subgroup2];
    }
  }
  return [];
};
